(function () {
  angular.module('MktzapApp.Factories')
    .factory('ExthubConfigsService', ExthubConfigsService);

  ExthubConfigsService.$inject = ['$resource'];

  function ExthubConfigsService ($resource) {
    return $resource(apiUrl + '/exthub-configs/:id', { id: '@id' }, {
      getConfig: { url: apiUrl + '/exthub-config', method: 'GET', params: { }, isArray: false },
      getConfigs: { url: apiUrl + '/exthub-configs', method: 'GET', isArray: false },
      saveConfigs: { method: 'POST' }
    });
  }
})();
